/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportExcelFileResponse } from '../../models/export-excel-file-response';
import { VendorAuctionDetailDto } from '../../models/vendor-auction-detail-dto';

export interface ApiVendorVendorAuctionExportItemPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorAuctionDetailDto
}

export function apiVendorVendorAuctionExportItemPost(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionExportItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportExcelFileResponse>> {
  const rb = new RequestBuilder(rootUrl, apiVendorVendorAuctionExportItemPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportExcelFileResponse>;
    })
  );
}

apiVendorVendorAuctionExportItemPost.PATH = '/api/vendor/vendor-auction/ExportItem';
